import { constants } from "@qgiv/core-js";
import receiptDefaultValues from "../components/P2PRegistrationControl/receiptDefaultValues";
import registrationAccountDefaultValues from "../components/P2PRegistrationControl/registrationAccountDefaultValues";

const {
    cms,
    ENUMS: {
        FormStatusType: { REGISTRATION_AVAILABLE },
    },
} = constants;
const isCms = cms === "1";

const QGIV = window.QGIV || {};

const initialState =
    Object.keys(QGIV).length > 0 &&
    QGIV.initialState &&
    QGIV.initialState.response
        ? QGIV.initialState.response
        : {};

const validInitialStateObject = Object.keys(initialState).length > 0;

export const activeFormInjections = QGIV.initialState.activeFormInjections
    ? QGIV.initialState.activeFormInjections
    : {};

// prettier-ignore
export const config =
    validInitialStateObject && initialState.config
        ? initialState.config : {};

export const currentForm =
    validInitialStateObject && initialState.currentForm
        ? initialState.currentForm
        : "";

export const categories =
    validInitialStateObject && initialState.categories
        ? initialState.categories
        : [];

export const classifications =
    validInitialStateObject && initialState.classifications
        ? initialState.classifications
        : [];

export const existingRegistrations =
    QGIV.initialState.existingRegistrations &&
    QGIV.initialState.existingRegistrations.length > 0
        ? QGIV.initialState.existingRegistrations
        : [{}];

export const hasParentRegistration = QGIV.initialState.hasParentRegistration
    ? QGIV.initialState.hasParentRegistration
    : false;

export const internalSettings =
    validInitialStateObject && initialState.internalSettings
        ? initialState.internalSettings
        : {};

export const parentRegistration =
    QGIV.initialState.parentRegistration &&
    Object.keys(QGIV.initialState.parentRegistration).length > 0
        ? QGIV.initialState.parentRegistration
        : {};

// Set default registration account values for cms
const registrationAccountInitialState = isCms
    ? {
          ...registrationAccountDefaultValues.registrationAccount,
      }
    : {
          ...initialState.registrationAccount,
      };

export const registrationAccount =
    validInitialStateObject && (initialState.registrationAccount || isCms)
        ? registrationAccountInitialState
        : {};

export const p2pSettings =
    validInitialStateObject && initialState.event_settings
        ? initialState.event_settings
        : {};

export const formSettings =
    validInitialStateObject && initialState.form_settings
        ? initialState.form_settings
        : {};

// prettier-ignore
export const teams =
    validInitialStateObject && initialState.teams
        ? initialState.teams
        : [];

export const fields =
    validInitialStateObject && initialState.custom_fields
        ? initialState.custom_fields
        : [];

export const cmsSettings =
    validInitialStateObject && initialState.cmsSettings
        ? initialState.cmsSettings
        : {};

export const products =
    validInitialStateObject && initialState.products
        ? initialState.products
        : [];

export const productSettings =
    validInitialStateObject && initialState.product_settings
        ? initialState.product_settings
        : {};

const createReceipts = () => {
    if (isCms) {
        return {
            receiptId: receiptDefaultValues.receipt.transaction.receiptId,
            [receiptDefaultValues.receipt.transaction.receiptId]: {
                ...receiptDefaultValues.receipt,
            },
        };
    }
    if (validInitialStateObject && initialState.receipt) {
        return {
            receiptId: initialState.receipt.transaction.receiptId,
            [initialState.receipt.transaction.receiptId]: {
                ...initialState.receipt,
            },
        };
    }
    return {};
};

export const receipts = createReceipts();

export const appSettings =
    validInitialStateObject && initialState.appSettings
        ? initialState.appSettings
        : // default to registration being available
          { formStatus: REGISTRATION_AVAILABLE };
